export function fmt(v: string | null | undefined, dateOnly = false): string {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  if (dateOnly) return `${dd}.${mm}.${d.getFullYear()}`;
  return `${dd}.${mm}, ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function money(minor: number, currency: string): string {
  const whole = Math.trunc(Math.abs(minor) / 100);
  const cents = Math.abs(minor) % 100;
  const s = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (cents ? `,${String(cents).padStart(2, '0')}` : '');
  return `${minor < 0 ? '-' : ''}${s} ${currency}`.trim();
}
